import {Action} from 'com/gongxigames/math/core/game/enums/Action';
import {ModuleState} from '@gongxigames/framework/slot/fragments/module/ModuleState';
import {FlowModuleEvents} from '@gongxigames/framework/slot/modules/flow';
import {BigWinEvents} from '@gongxigames/framework/slot/modules/bigwin';
import {SpinButtonEvents} from '@gongxigames/framework/slot/modules/spinbutton';
import {ReelsEvents} from '@gongxigames/framework/slot/modules/reels';
import {WinMeterEvents} from '@gongxigames/framework/slot/modules/winmeter';
import {WinPresentationView} from '@gongxigames/framework/slot/modules/winpresentation/WinPresentationView';
import {WinPresentationModule} from '@gongxigames/framework/slot/modules/winpresentation/WinPresentationModule';

export class WinPresentationPickState extends ModuleState<WinPresentationView, WinPresentationModule> {
    protected setupEvents(): void {
        this.setEventHandler(FlowModuleEvents.SKIP_PICK_BONUS_AWARD, this.skipAward.bind(this));
        this.setEventHandler(FlowModuleEvents.START_PICK_BONUS_AWARD, this.startAward.bind(this));
        this.setEventHandler(BigWinEvents.FINISHED, this.onBigWinFinished.bind(this));
        this.setEventHandler(SpinButtonEvents.SPIN_BUTTON_PRESSED, this.finishAward.bind(this));
        this.setEventHandler(ReelsEvents.REELS_SPINNING_STARTED, this.finishAward.bind(this));
    }

    public onEnterState(): void {
    }

    public onLeaveState(): void {
    }

    protected skipAward(): void {
        this.emit(WinMeterEvents.SET_VALUE, this.module.logic.getTotalWin(), true);
        this.backToBasicState();
    }

    protected startAward(): void {
        this.module.playPickWin();
    }

    protected finishAward(): void {
        this.module.stop();
        this.emit(WinMeterEvents.SNAP_TO_FINAL_VALUE);
        this.module.stopMeter(false);
        this.backToBasicState();
    }

    protected onBigWinFinished(): void {
        this.emit(WinMeterEvents.SNAP_TO_FINAL_VALUE);
        this.view.playPayAnimation();
    }

    protected backToBasicState(): void {
        const {nextAction} = this.module.logic;

        if (nextAction === Action.FREESPIN) {
            this.module.gotoState(WinPresentationModule.FREESPINS_BASIC_STATE);
        } else {
            this.module.gotoState(WinPresentationModule.BASIC_STATE);
        }
    }
}
